import { render, staticRenderFns } from "./TeamBuilderAddMembers.vue?vue&type=template&id=bb1188f8&scoped=true&lang=pug&"
import script from "./TeamBuilderAddMembers.vue?vue&type=script&lang=js&"
export * from "./TeamBuilderAddMembers.vue?vue&type=script&lang=js&"
import style0 from "./TeamBuilderAddMembers.vue?vue&type=style&index=0&id=bb1188f8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1188f8",
  null
  
)

export default component.exports